/** @format */

import React, { useState, useEffect, useContext } from "react";
import "./index.scss";
import ReactApexChart from "react-apexcharts";
import { ENG_DETAILS_STATE, getYearData } from "../helper";
import {
  Typography,
  Box,
  ToggleButtonGroup,
  ToggleButton,
  IconButton,
} from "@mui/material";
import ChartTable from "../../chart-table";
import { TICKET_STATUS } from "../../../core/ticket-filters/config";
import { FINANCIAL_YEAR } from "../../../core/india-map/utils";
import AppContext from "../../../utils/context";
import { COST_ACCESS_EMAILS, USER_ROLES } from "../../../utils/constants";
import CustomDashboardFilters from "../../custom-dashboard-filters";
import DownloadIcon from "@mui/icons-material/Download";
import { HTTP_METHODS, invokeApi } from "../../../utils/http-service";
import { HOSTNAME, REST_URLS } from "../../../utils/endpoints";

const PastEngineReplacementTrend = ({
  data = {},
  loadEngineReplacement,
  viewType,
  setViewType,
}) => {
  const [options, setOptions] = useState({});
  const [series, setSeries] = useState([]);
  const [headers, setHeaders] = useState([]);
  const [rows, setRows] = useState([]);
  const { userDetails = {}, engineReplacementDashboardFilter } =
    useContext(AppContext);

  useEffect(() => {
    if (Object.keys(data).length) {
      const { options, series } = ENG_DETAILS_STATE(data);
      setOptions(options);
      setSeries(series);

      const yearTotals = Object.entries(data).map(([year, yearData]) => {
        const totalCount =
          yearData.total ||
          Object.values(yearData.months).reduce((sum, monthData) => {
            if (
              typeof monthData === "object" &&
              monthData.replacementCount !== undefined
            ) {
              return sum + monthData.replacementCount;
            }
            return sum + (typeof monthData === "number" ? monthData : 0);
          }, 0);
        return { year, totalCount };
      });

      const yearList =
        yearTotals?.map((ele) => {
          const [startYear, endYear] = ele.year.split("-");
          return `${startYear} - ${endYear.slice(-2)}`;
        }) || [];
      const yearCountList = yearTotals?.map((ele) => ele.totalCount) || [];

      const tableHead = [
        "",
        ...yearList,
        "APR",
        "MAY",
        "JUN",
        "JUL",
        "AUG",
        "SEP",
        "OCT",
        "NOV",
        "DEC",
        "JAN",
        "FEB",
        "MAR",
      ];

      const yearMonthsData =
        Object.entries(data).map(([year, yearData], index) => {
          const monthData = getYearData(yearData);
          const nullArray = new Array(yearList.length).fill("");
          return [year, ...nullArray, ...monthData];
        }) || [];

      const rowsData = [
        [
          "YOY",
          ...yearCountList,
          "",
          "",
          "",
          "",
          "",
          "",
          "",
          "",
          "",
          "",
          "",
          "",
        ],
        ...yearMonthsData,
      ];
      setHeaders(tableHead);
      setRows(rowsData);
    } else {
      setOptions({});
      setSeries([]);
      setHeaders([]);
      setRows([]);
    }
  }, [data]);

  const handleViewChange = (_, newValue) => {
    if (newValue) {
      setViewType(newValue);
    }
  };

  const downloadEngineReplacementTrend = () => {
    invokeApi(
      HTTP_METHODS.GET,
      `${HOSTNAME}${REST_URLS.DOWNLOAD_TICKETS}`,
      null,
      {
        ...engineReplacementDashboardFilter,
        engineReplacement: true,
      },
      "blob"
    )
      .then((res) => {
        if (!res.message) {
          const url = window.URL.createObjectURL(res);
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", `Engine Replacement Tickets.xlsx`);
          document.body.appendChild(link);
          link.click();
          link.remove();
        }
      })
      .catch((err) => console.error(err));
  };

  return (
    <div className="past-engine-replacement-tend">
      <Box sx={{ display: "flex", alignItems: "center" }}>
        <Typography variant="h6">ENGINE REPLACEMENT TREND</Typography>
        <IconButton>
          <DownloadIcon onClick={downloadEngineReplacementTrend} />
        </IconButton>
      </Box>

      {COST_ACCESS_EMAILS?.includes(userDetails?.email) && (
        <Box sx={{ display: "flex", justifyContent: "flex-end", mb: 2 }}>
          <ToggleButtonGroup
            value={viewType}
            exclusive
            onChange={handleViewChange}
            size="small"
          >
            <ToggleButton value="count">Count Wise</ToggleButton>
            <ToggleButton value="cost">Cost Wise</ToggleButton>
          </ToggleButtonGroup>
        </Box>
      )}

      {Object.keys(data).length > 0 ? (
        <div className="chart-container">
          <ReactApexChart
            options={options}
            series={series}
            height={350}
            width="100%"
          />

          <ChartTable headers={headers} rows={rows} />
        </div>
      ) : (
        <Typography sx={{ mt: 10, mb: 10, textAlign: "center" }}>
          No Data{" "}
        </Typography>
      )}
    </div>
  );
};

export default PastEngineReplacementTrend;
